<template>
  <el-card style="height: 740px;overflow-y: scroll;">
    <div class="region">
      <p>检验平台编辑</p>
      <el-button @click="dialogVisible=true">批量处理</el-button>
      <el-table border :data="tableData" :header-cell-style="{'background-color': '#f6f6f6'}"
                style="width: 100%;margin-top: 20px;" @select="select" @select-all="select_all">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column align="center" prop="username" width="150px" label="用户名称"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="name" label="检验设备"></el-table-column>
        <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="pageSize"
                     hide-on-single-page @current-change="changePage" @prev-click="changePage"
                     @next-click="changePage" :total="total">
      </el-pagination>

      <el-dialog :modal="false" class="dialog" :visible.sync="dialogVisible" :show-close="false"
                 @close="closeDialog" width="30%">
        <el-form>
          <el-form-item label="检验平台">
            <el-select v-model="platform">
              <el-option value="罗" label="罗"></el-option>
              <el-option value="雅" label="雅"></el-option>
              <el-option value="贝" label="贝"></el-option>
              <el-option value="西" label="西"></el-option>
              <el-option value="迈" label="迈"></el-option>
              <el-option value="其他" label="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import {edit_testing_instruments, get_testing_instruments} from "@/api/TestingInstruments";

export default {
  name: 'TestingInstrumentsView',
  data: function () {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      current_page: 1,
      platform: undefined,
      dialogVisible: false,
      ids: []
    }
  },
  methods: {
    getRegionData() {
      get_testing_instruments(this.page, this.pageSize).then((res) => {
        
        const {data} = res
        if (data['code'] === 200) {
          this.tableData = data['data']
          this.total = data['count']
        }
      })
    },
    closeDialog() {
      this.platform = undefined
      this.dialogVisible = false
    },
    submitRegionForm() {
      edit_testing_instruments(this.ids, this.platform).then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.$message.success('编辑成功！')
          this.dialogVisible = false
          this.getRegionData()
        } else {
          this.$message.error(data['error'])
        }
      })
    },
    changePage(page) {
      this.page = page
      this.getRegionData()
    },
    select_all(selection) {
      this.ids = selection.map(item => {
        return item.id
      })
    },
    select(selection, row) {
      this.ids = selection.map(item => {
        return item.id
      })
    }
  },
  created() {
    this.getRegionData();
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>